export default __webpack_public_path__ + "static/media/italia.a28e20f1.png";